import { ReactElement, ReactNode } from "react";
import { Link } from "react-router";

interface Props {
    nombreCampo: string;
    texto: string | ReactNode;
    icono: ReactElement<any, any>;
}

export function TaskInformationField({ texto, nombreCampo, icono }: Props) {
    return (
            <div className="flex gap-x-2 items-center border-22 border-red-800">
                <div className="flex gap-x-2 items-center w-[30%]">
                    {icono}
                    <p className="font-semibold text-slate-700 grow-0">{nombreCampo}</p>
                </div>

                <div className="grow-0 w-[70%]">
                    {texto}
                </div>
            </div>

    );
}